module.exports = {
      id: "car-usage",
      viewBox: "0 0 512 205",
      url: __webpack_public_path__ + "images/sprites/transport.svg#car-usage",
      toString: function () {
        return this.url;
      }
    }